export default orderNumber => `
  {
    order(orderNumber: "${orderNumber}") {
      number
      completedAt
      email
      isTaxIncluded
      taxForGoogleAnalytics
      total
      shipmentTotal
      netAmount
      state
      shippingAddress {
        firstname
        lastname
        address1
        address2
        zipcode
        city
        state_id
        country_id
        phone
        document_number
        ibge_city_code
        neighborhood
        countryData {
          name
          iso
        }
        stateData {
          abbr
          name
          id
        }
      }
      billingAddress {
        firstname
        lastname
        address1
        address2
        zipcode
        city
        state_id
        country_id
        phone
        document_number
        ibge_city_code
        neighborhood
        countryData {
          name
          iso
        }
        stateData {
          abbr
          name
          id
        }
      }
      shippingRates {
        id
        name
        price
        displayPrice
        selected
        estimatedDelivery
        notice
      }
      items {
        variantId
        sku
        masterSku
        ean
        color
        productName
        productType
        groupName
        imageUrl
        price
        productPath
        quantity
        size
      }
      promotionAdjustment {
        code
        amount
      }
      taxAdjustments {
        label
        amount
        type
      }
    }
    currentStore {
      name
      currency {
        code
      }
    }
  }
`
